import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Space,
  Table,
  Tag,
} from "antd";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CustomUpload from "../../../../utils/CustomUpload";
import GlobalContext from "../../../../context/GlobalContext";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { nanoid } from "nanoid";
import axiosInstance from "../../../../utils/axios";
import {
  updateActionAffaire,
  updateStatusApprenants,
  uploadDocumentAffaire,
} from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import { debugIntegration } from "@sentry/react";

const ModalUploadPVCertifs = ({ openModal, setOpenModal, setPv, pv }) => {
  const { t } = useTranslation();
  const { form } = useContext(GlobalContext);
  const [modalVisible, setModalVisible] = useState({});
  const [selectedDiplomaFiles, setSelectedDiplomaFiles] = useState([]);
  const [comments, setComments] = useState({});
  const { setIsLoading } = useLoader();

  const ID_ACCEPT = parseInt(
    import.meta.env.VITE_APP_ID_STATUS_APPRENANT_ACCEPTE
  );
  const ID_REFUSE = parseInt(
    import.meta.env.VITE_APP_ID_STATUS_APPRENANT_NON_ABOUTI
  );

  useEffect(() => {
    form.setFieldsValue({
      [`PvSessionUpload${openModal?.data?.[0]?.id_formation}`]: pv || "",
    });
    if (openModal?.data?.length) {
      const initial = {};
      openModal.data.forEach((rec) => {
        if (rec.id_statut_apprenant === ID_ACCEPT) initial[rec.id] = true;
        if (rec.id_statut_apprenant === ID_REFUSE) initial[rec.id] = false;
      });
      setModalVisible(initial);
    }
  }, [openModal?.data]);

  const handleValidate = async () => {
    const openIds = openModal?.data?.map((item) => item.id);
    const incompleteValidation = openIds.some(
      (id) => modalVisible[id] !== true && modalVisible[id] !== false
    );

    if (incompleteValidation) {
      notification.error({
        message: t("Erreur"),
        description: t(
          "Tous les apprenants doivent être validés ou non aboutis avant de continuer."
        ),
      });
      return;
    }
    const apprenantsValidesSansDiplome = openModal.data.filter(
      (item) =>
        modalVisible[item.id] === true &&
        !selectedDiplomaFiles[item.id] &&
        !item?.documents?.content_diplome
    );

    if (apprenantsValidesSansDiplome.length > 0) {
      notification.error({
        message: t("Erreur"),
        description: t(
          "Tous les apprenants validés doivent avoir une Certification téléversé."
        ),
      });
      return;
    }

    if (
      pv === "" &&
      openModal?.etat_affaire !==
        import.meta.env
          .VITE_APP_ID_STATUS_COMPLEMENT_DOSSIER_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE
    ) {
      notification.error({
        message: t("Erreur"),
        description: t("Veuillez téléverser le PV de la session."),
      });
      return;
    }

    setIsLoading(true);

    const apprenants = openIds.map((id) => ({
      id_apprenant: id,
      statut: modalVisible[id] ? ID_ACCEPT : ID_REFUSE,
      commentaire: comments[id] || "",
    }));

    const payload = {
      apprenants,
      id_formation: parseInt(sessionStorage.getItem("id_formation_apprenants")),
    };

    const data = await updateStatusApprenants(payload);

    if (data) {
      const id_affaire = sessionStorage.getItem(
        "id_affaire_to_upload_docs_session"
      );
      const idStatus = import.meta.env
        .VITE_APP_ID_STATUS_PV_AJOUTE_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE;

      const dataStatus = await updateActionAffaire({
        id_affaire,
        id_status: idStatus,
      });

      if (dataStatus) {
        setIsLoading(false);
        setOpenModal([]);
        window.location.reload();
      }
    } else {
      notification.error({
        message: "Erreur",
        description:
          "Erreur lors de l'enregistrement des statuts des apprenants",
      });
    }
  };

  const myCustomRequest = (id, { file, onSuccess }) => {
    const id_affaire = sessionStorage.getItem(
      "id_affaire_to_upload_docs_session"
    );
    const formData = new FormData();
    const newFileName = `DOC-${nanoid(12)}.${file.name.split(".").pop()}`;
    const renamedFile = new File([file], newFileName, { type: file.type });

    formData.append("id_apprenant", id);
    formData.append("document", renamedFile);
    formData.append("id_affaire", id_affaire);

    axiosInstance
      .post(
        `${import.meta.env.VITE_APP_GEOPROD_API}/upload_doc_apprenant`,
        formData,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        onSuccess(res);
        debugIntegration;
        setSelectedDiplomaFiles((prev) => ({
          ...prev,
          [id]: res?.data?.url,
        }));
      });
  };

  const customRequestPv = async (id, { file, onSuccess, onError }) => {
    const id_affaire = sessionStorage.getItem(
      "id_affaire_to_upload_docs_session"
    );
    const id_type_doc = import.meta.env
      .VITE_APP_ID_PORTE_DOCUMENT_PV_SESSION_NON_HOMOLOGUEE_CONTINUE;

    const formData = new FormData();
    const newFileName = `DOC-${nanoid(12)}.${file.name.split(".").pop()}`;
    const renamedFile = new File([file], newFileName, { type: file.type });

    formData.append("id_affaire", id_affaire);
    formData.append("id_type_doc", id_type_doc);
    formData.append("file[]", renamedFile);
    formData.append("name_doc", "document_name");
    formData.append("key", "document_key");

    try {
      const res = await uploadDocumentAffaire(formData);
      const fileUrl = res.data.path;

      form.setFieldsValue({ document_key: fileUrl });
      setPv(fileUrl);
      form.setFieldsValue({
        [`PvSessionUpload${openModal?.data?.[0]?.id_formation}`]: fileUrl,
      });
      onSuccess(res);
    } catch (err) {
      console.error(err);
      onError(err);
    }
  };

  const columns = [
    { title: "Nom", dataIndex: "name", key: "name" },
    { title: "Prénom", dataIndex: "surname", key: "surname" },
    { title: "Date de naissance", dataIndex: "DN", key: "DN" },
    {
      title: "Numéro de l'identifiant",
      key: "cin",
      render: (_, record) =>
        record?.data_from?.typeIdentifiant?.toLowerCase() === "cin"
          ? record?.cin
          : record?.data_from?.typeIdentifiant?.toLowerCase() === "passeport" ||
            record?.nationality !== "تونسية"
          ? record?.passport
          : record?.extrait_naissance,
    },
    {
      title: "Niveau",
      key: "niveau",
      render: (_, record) => record?.data_from?.niveau || "Non renseigné",
    },
    {
      title: "Commentaire",
      key: "commentaire",
      render: (_, record) => (
        <Input.TextArea
          rows={2}
          placeholder="Ajouter un commentaire"
          value={comments[record.id] || ""}
          onChange={(e) =>
            setComments((prev) => ({
              ...prev,
              [record.id]: e.target.value,
            }))
          }
        />
      ),
    },
    {
      title: "Certification",
      key: "diplome",
      render: (_, record) => (
        <CustomUpload
          field={{
            buttonName: "Téléverser la Certification",
            name: `PvSessionUpload_${record.id}`,
          }}
          multiple={false}
          accept=".png,.jpg,.jpeg,.pdf"
          customRequest={myCustomRequest}
          id={record.id}
          setSelectedDiplomaFiles={setSelectedDiplomaFiles}
          type="diplome"
          showIcon={true}
          value={record?.documents?.content_diplome}
        />
      ),
    },
    {
      title: "Statut",
      key: "statut",
      render: (_, record) => {
        let status;
        if (record.id in modalVisible) {
          status = modalVisible[record.id];
        } else if (record.id_statut_apprenant === ID_ACCEPT) {
          status = true;
        } else if (record.id_statut_apprenant === ID_REFUSE) {
          status = false;
        }

        if (status === true) {
          return (
            <Space>
              <Tag color="#26b6a7">Accepté</Tag>
              <Button
                type="link"
                onClick={() =>
                  setModalVisible((prev) => ({
                    ...prev,
                    [record.id]: undefined,
                  }))
                }
              >
                Modifier
              </Button>
            </Space>
          );
        }

        if (status === false) {
          return (
            <Space>
              <Tag color="#ff4d4f">Non abouti</Tag>
              <Button
                type="link"
                onClick={() =>
                  setModalVisible((prev) => ({
                    ...prev,
                    [record.id]: undefined,
                  }))
                }
              >
                Modifier
              </Button>
            </Space>
          );
        }

        return (
          <Space>
            <Button
              icon={<CheckOutlined />}
              type="text"
              onClick={() =>
                setModalVisible((prev) => ({ ...prev, [record.id]: true }))
              }
              style={{ color: "#26b6a7" }}
            >
              Accepter
            </Button>
            <Button
              icon={<CloseOutlined />}
              type="text"
              onClick={() =>
                setModalVisible((prev) => ({ ...prev, [record.id]: false }))
              }
              style={{ color: "#ff4d4f" }}
            >
              Non abouti
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <Modal
      open={openModal?.data?.length > 0}
      onCancel={() => setOpenModal([])}
      width={1800}
      footer={null}
      centered
    >
      <Form form={form} layout="vertical" onFinish={handleValidate}>
        <Col lg={24}>
          {/* <Form.Item label={t("PV de la session")} name= {`PvSessionUpload${openModal?.data?.[0]?.id_formation}`} rules={[{ required: true }]}> */}
            <CustomUpload
              field={{
                buttonName: t("Téléverser une pièce jointe"),
                title: "Téléverser le PV de la session",
                name: `PvSessionUpload${openModal?.data?.[0]?.id_formation}`,
              }}
              multiple={false}
              accept=".png,.jpg,.jpeg,.pdf"
              customRequest={customRequestPv}
              id={null}
              setSelectedDiplomaFiles={null}
              type="pv"
              showIcon={true}
              value={pv}
            />
          {/* </Form.Item> */}
        </Col>
        <Card bordered={false}>
          <h2>{t("Liste des participants")}</h2>
          <Table
            dataSource={openModal?.data}
            columns={columns}
            rowKey="id"
            pagination={false}
          />
        </Card>
        <Button
          style={{ marginInline: "0.5rem" }}
          key="cancel"
          onClick={() => setOpenModal([])}
        >
          {t("Annuler")}
        </Button>
        <Button key="validate" type="primary" htmlType="submit">
          {openModal?.etat_affaire !==
          import.meta.env
            .VITE_APP_ID_STATUS_COMPLEMENT_DOSSIER_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE
            ? t("Valider")
            : t("Compléter la demande")}
        </Button>
      </Form>
    </Modal>
  );
};

export default ModalUploadPVCertifs;
